import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-error-recipt',
    templateUrl: './error-recipt.component.html',
    styleUrls: ['./error-recipt.component.scss'],
    standalone: false
})
export class ErrorReciptComponent implements OnInit {
  @Input() icon: string = '';
  @Input() mainCopy:string = '';
  @Output() accept = new EventEmitter<void>();

 
  constructor() { }

  ngOnInit(): void {
  }
 onAcceptClick(): void {
    this.accept.emit(); // emite evento al padre
  }
}
